// NPM dependencies
import $ from 'jquery';
import 'foundation-sites';
import 'slick-carousel';
import 'magnific-popup';
import objectFitImages from 'object-fit-images';
import 'vanilla-fitvids';
import 'lightgallery';
import 'lg-thumbnail';

// Vue
var Vue = require('vue');
import VeeValidate from 'vee-validate';
window.Vue = Vue;

Vue.use(VeeValidate);

// Custom Imports
import './aras-kids-modules/submenu';
import './aras-kids-modules/pager';
import './aras-kids-modules/hashchange';
// import JsBoxes from './aras-kids-modules/boxes';
// import JsValidateForm from './aras-kids-modules/validate-form';
// import JsQuizValidation from './aras-kids-modules/quiz-validation';
import JsSubNavMenu from './aras-kids-modules/sub-nav-menu';
import JsSlick from './aras-kids-modules/slick';
import JsMagnific from './aras-kids-modules/magnific';
import JsIE10 from './aras-kids-modules/IE10-compat';
import JsGuideDisplay from './aras-kids-modules/guide-display';
import ArasQuizVue from './aras-kids-modules/aras-kids-quiz';
import JsFontSize from './aras-kids-modules/font-size';
import JsScrollTo from './aras-kids-modules/smooth-scroll-to';
import JsSubNavDropdown from './aras-kids-modules/submenu';
import JsGallery from '../../src/components/03-ui/gallery/gallery';
import JsSiteHeader from '../../src/components/03-ui/site-header/site-header';

$(document).ready(() => {
  // Init foundation on doc ready
  $(document).foundation();

  // Object Fit Polyfill
  // https://github.com/bfred-it/object-fit-images
  objectFitImages();

  ArasQuizVue.init(Vue);

  JsSubNavMenu.init();
  JsSlick.init();
  JsMagnific.init();
  JsIE10.init();
  JsGuideDisplay.init();

  JsSubNavDropdown.init();
  JsFontSize.init();
  JsGallery.init();
  JsSiteHeader.init();
  JsScrollTo.init();
});

$(window).on('load', function () {
  $('.page-preloader').fadeOut(1000);
});



// WEBPACK FOOTER //
// ./src/js/aras_kids.js